import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  limit: 20,
  page: 1,
  total: 0,
  totalPages: 1,
};

export const packagePaginateSlice = createSlice({
  name: "packagePaginateSlice",
  initialState,
  reducers: {
    setPackagePageLimit: (state, action) => {
      state.limit = action.payload;
    },
    setPackageCurrentPage: (state, action) => {
      state.page = action.payload;
    },
    setPackageTotalCount: (state, action) => {
      state.total = action.payload;
    },
    setPackageTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    resetPackagePagination: (state, action) => {
      state.limit = 20;
      state.page = 1;
      state.total = 0;
      state.totalPages = 1;
    },
  },
});

export const {
  setPackagePageLimit,
  setPackageCurrentPage,
  setPackageTotalCount,
  setPackageTotalPages,
  resetPackagePagination,
} = packagePaginateSlice.actions;

export default packagePaginateSlice.reducer;
